// extracted by mini-css-extract-plugin
export var borderRadius = "_ek-4";
export var large = "_ek-3";
export var logoContainer = "_ek-0";
export var nameLogo = "_ek-2";
export var small = "_ek-1";